import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';

import PrintChecklistTaskItem from '../PrintChecklistTaskItem';

import checklistDoodle from '../../../../../assets/images/checklistV2/checklist-doodle.svg';
import { buildPages } from './helpers';

import './PrintChecklistTaskList.less';

const PrintChecklistTaskList = (props) => {
  const { checklistTasksGroups, checklistTasks, className, filteredChecklistTaskGroups, filtersActive, weddingDate } = props;
  const taskGroups = filtersActive ? filteredChecklistTaskGroups : checklistTasksGroups;
  const pages = buildPages(taskGroups);
  const formattedWeddingDate = weddingDate && moment(weddingDate).utc().format('LL');

  const renderChecklistDoodle = () => (
    <div className="print-checklist__checklist-doodle-container">
      <img
        className="print-checklist__checklist-doodle"
        src={checklistDoodle}
        alt="Checklist"
      />
    </div>
  );

  const renderChecklistHeader = () => (
    <Fragment>
      <h1 className="print-checklist__title">Wedding Checklist</h1>
      {formattedWeddingDate && (<p className="print-checklist__date">{formattedWeddingDate}</p>)}
    </Fragment>
  );

  return (
    <div className={cx('print-checklist__taskList-container', className)}>
      {pages.map((page, pageIndex) => (
        <div className="print-checklist-page" key={`checklist-page-${pageIndex}`}>
          <div className="print-checklist__page-number-container">Page {pageIndex + 1} of {pages.length}</div>
          { pageIndex === 0 && renderChecklistHeader()}
          <div className="print-checklist-page__inner">
            {page.map((pageRow, pageRowIndex) => {
              if (pageRow.type === 'TASK_GROUP_HEADER') {
                return (
                  <div className="task-list-section__header" key={`checklist-page-${pageIndex}-row-${pageRowIndex}`}>
                    {/* Add the Checklist Doodle for only the first page first row */}
                    { (pageIndex === 0 && pageRowIndex === 0) && renderChecklistDoodle()}
                    <span className={cx('task-list-section__header-title', { 'print-checklist__first-header': (pageIndex === 0 && pageRowIndex === 0) })}>{pageRow.label}</span>
                  </div>
                );
              }
              // The row represents a task item:
              const task = checklistTasks[pageRow.taskId] || {};
              return (
                <PrintChecklistTaskItem
                  key={task.id || pageRowIndex}
                  title={task.title}
                  checklistTemplateName={task.checklist_template_name}
                  isComplete={Boolean(task.completed_at)}
                  dueAt={task.due_at}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

PrintChecklistTaskList.propTypes = {
  checklistTasksGroups: PropTypes.arrayOf(PropTypes.object),
  filteredChecklistTaskGroups: PropTypes.arrayOf(PropTypes.object),
  checklistTasks: PropTypes.shape({}),
  className: PropTypes.string,
  filtersActive: PropTypes.bool,
  weddingDate: PropTypes.string,
};

PrintChecklistTaskList.defaultProps = {
  checklistTasksGroups: [],
  checklistTasks: {},
  className: '',
};

export default PrintChecklistTaskList;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistTaskList/PrintChecklistTaskList.jsx